import React, { useEffect } from "react";
import Page from "./Page";
import "./AssessPage.scss"; // Assuming you have a CSS file for styles
import { goToLPDetailUtil } from "../../utils/AppUtils";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";
import ActionPathCard from "../components/card/ActionPathCard";
import SessionRequest from "../components/home/SessionRequest";

const CompletedPage = () => {
  const actionArr = [
    {
      lp_id: "122",
      id: "122",
      thumbnail: "/images/finwell-img/actionpath1.svg",
      color: "yellow-c",
      is_level: false,
      source: "broker",
      origin: "broker",
      ob_lp: "0",
      provider_id: "568",
      provider_name: "Family finances",
      lp_name: "Create a spending plan",
      status: "completed",
      product_type: "learningpath",
    },
    {
      lp_id: "123",
      id: "123",
      thumbnail: "/images/finwell-img/actionpath2.svg",
      color: "pink-c",
      is_level: false,
      source: "broker",
      origin: "broker",
      ob_lp: "0",
      provider_id: "568",
      provider_name: "Family finances",
      lp_name: "Build an emergency fund",
      status: "completed",
      product_type: "learningpath",
    },
    {
      lp_id: "124",
      id: "124",
      thumbnail: "/images/finwell-img/actionpath3.svg",
      color: "blue-c",
      is_level: false,
      source: "broker",
      origin: "broker",
      ob_lp: "0",
      provider_id: "568",
      provider_name: "Family finances",
      lp_name: "Reduce your financial stress",
      status: "completed",
      product_type: "learningpath",
    },
  ];

  const navigate = useNavigate();
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const [coachUrl, setCoachUrl] = React.useState("");

  useEffect(() => {
    let userDetailResLocal = userDetailRes;
    console.log("userDetailResLocal", userDetailResLocal);
    if (!_.isEmpty(userDetailResLocal)) {
      if (userDetailResLocal?.status === "success") {
        let journey = userDetailResLocal?.payload?.payload?.money_journey;
        setCoachUrl(journey?.coach);
      }
    }
  }, [userDetailRes]);

  return (
    <>
      <section className="suceess-section">
        <div className="assssbanners text-center mb-3">
          <img
            src="/images/finwell-img/Group13873.svg"
            alt="banner"
            width="378"
            height="374"
            className="img-fluid"
          />
        </div>
        <div className="money-section-inner text-center mt-2">
          <h5>
            Nice work! you’ve taken an important step toward financial
            confidence.
          </h5>
          <p className="mb-0">
            You’ve just taken a big step toward clarity and control over your
            finances. Keep going — your next move matters. You can retake this
            snapshot anytime to get updated recommendations.
          </p>

          <p className="mt-4 mb-2">
            <strong>
              We’ll use your responses to customize your homepage and suggest
              content that fits your goals.
            </strong>
          </p>
          <p className="text-center cursor-pointer">
            <a
              onClick={() => {
                navigate("/explore?pillar_id=all");
              }}
            >
              Explore your personalized dashboard
            </a>
          </p>
        </div>
        <section className="explore-page mt-4">
          <div className="continue-section w-100">
            <div className="left text-center w-100">
              <h3> Based on your answers, we recommend:</h3>
            </div>
          </div>
          <div className="row">
            {actionArr.map((action, index) => (
              <ActionPathCard index={index} action={action} />
            ))}
          </div>
          <div className="row justify-content-center">
            <div id="coachingModule" className="col-md-4">
              <SessionRequest from="right" coach={coachUrl} />
            </div>
          </div>
        </section>
        {/* <div className='row justify-content-center'>
                        <div id="coachingModule" className="col-md-4">
                            <div className="card-money justify-content-between" tabIndex="0" aria-label="Take the tour. Learn where everything is so you can start digging into the content.">
                                <div className="caochtext">
                                    <div class=" mb-3 align-items-center">
                                        <h3 className="card-money-title col-12 mb-0">Want help making the most of your results?  Book a session with your coach to explore your recommendations.</h3>
                                    </div>
                                </div>
                               {false && <div class="avatar-group">
                                    <img src="/images/finwell-img/avatar1.png" alt="Avatar 1" class="avatar" />
                                    <img src="/images/finwell-img/avatar2.png" alt="Avatar 2" class="avatar" />
                                    <img src="/images/finwell-img/avatar3.png" alt="Avatar 3" class="avatar" />
                                    <img src="/images/finwell-img/avatar4.png" alt="Avatar 4" class="avatar" />
                                    <img src="/images/finwell-img/avatar1.png" alt="Avatar 5" class="avatar" />
                                    <img src="/images/finwell-img/avatar2.png" alt="Avatar 6" class="avatar" />
                                </div> }
                                <div className="btnsec money-section-inner mt-2 cursor-pointer" onClick={()=>{window.open(coachUrl,"_blank")}}>
                                    <a >Schedule a session</a>
                                </div>
                            </div>
                        </div>
                    </div> */}
      </section>
    </>
  );
};

export default CompletedPage;
